import React, { useEffect, useMemo } from "react";
import Dashboard from "components/dashboard";
import { PageHeaderBar, PageSection } from "components/page";
import { getEventQuery } from "./details-page";
import { useAuthDataContext } from "components/auth";
import { RestrictedEventVisible } from "pages/event/utils";
import { ThumbnailLiveViewer } from "components/thumbnail";
import { useQuery, QueryResponseHandler } from "components/graphql";

const handleGetDataFromQuery = data => {
  const thumbnailPath =
    data && data.event && data.event.infoBert && data.event.infoBert.iaDebugUrl ? data.event.infoBert.iaDebugUrl : null;
  return { thumbnailPath, thumbnailDate: null };
};

const handleGetScoreDataFromQuery = data => {
  const thumbnailPath =
    data && data.event && data.event.infoBert && data.event.infoBert.iaScoreDebugUrl
      ? data.event.infoBert.iaScoreDebugUrl
      : null;
  return { thumbnailPath, thumbnailDate: null };
};

const EventAlgorithmViewerPage = ({
  match: {
    params: { id, customerId },
  },
  history,
  intl,
}) => {
  const { hasAdminPrivileges } = useAuthDataContext();
  const query = useMemo(() => getEventQuery({ eventId: id, customerId, hasAdminPrivileges }), [
    id,
    hasAdminPrivileges,
    customerId,
  ]);
  const { data, error, loading } = useQuery(query);
  const event = data.event;

  useEffect(() => {
    if (history.length === 1) {
      history.push("/event/list");
      history.push(`/event/details/${id}/customer/${customerId}`);
      history.push(`/event/algorithm-viewer/${id}/customer/${customerId}`);
    }
  });

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={event}>
        <RestrictedEventVisible event={event}>
          <PageHeaderBar
            showBackButton
            title="app.page.event.algorithmViewer.title"
            titleParams={{ eventTitle: event ? event.title : "" }}
          />
          <PageSection>
            <ThumbnailLiveViewer
              intervalsInSeconds={[1, 2, 3, 4, 5, 10, 30]}
              query={query}
              getThumbnailDataFromQueryResults={handleGetDataFromQuery}
              showThumbnail
              showThumbnailDate={false}
              noDataMessage={intl.formatMessage({ id: "app.page.event.algorithmViewer.noimage" })}
            />
          </PageSection>
          <br />
          <PageSection>
            <ThumbnailLiveViewer
              intervalsInSeconds={[1, 2, 3, 4, 5, 10, 30]}
              query={query}
              getThumbnailDataFromQueryResults={handleGetScoreDataFromQuery}
              showThumbnail
              showThumbnailDate={false}
              noDataMessage={intl.formatMessage({ id: "app.page.event.algorithmViewer.noimage" })}
            />
          </PageSection>
        </RestrictedEventVisible>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default EventAlgorithmViewerPage;
